/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetRoleSortOrder
 */
export interface WidgetRoleSortOrder {
    /**
     * 
     * @type {string}
     * @memberof WidgetRoleSortOrder
     */
    role: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetRoleSortOrder
     */
    sortOrder: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the WidgetRoleSortOrder interface.
 */
export function instanceOfWidgetRoleSortOrder(value: object): value is WidgetRoleSortOrder {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function WidgetRoleSortOrderFromJSON(json: any): WidgetRoleSortOrder {
    return WidgetRoleSortOrderFromJSONTyped(json, false);
}

export function WidgetRoleSortOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetRoleSortOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
    };
}

export function WidgetRoleSortOrderToJSON(json: any): WidgetRoleSortOrder {
    return WidgetRoleSortOrderToJSONTyped(json, false);
}

export function WidgetRoleSortOrderToJSONTyped(value?: WidgetRoleSortOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
    };
}

